import { Locale } from '@core/Entities/Locale/Locale.entity';
import { mappedLocales } from '@core/Utils/Intl/MappedLocales';

export const getFormattedDate = (value: Date, locale: Locale) => {
  const dateObj = new Date(value);
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  };

  const formatter = new Intl.DateTimeFormat(mappedLocales[locale], options);

  const formattedDate = formatter.format(dateObj);
  return formattedDate;
};
